module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2017_01.83230a63.jpg";